import ENVIRONMENT from '@/environments/environment';
import { NotificationType } from '@/interfaces/CustomerInterface/CustomerInterface';
import { getTodayDate } from '@/utils/dateHelper';

import Api from '../../utils/apiHelper';
import { allResponse } from '../eDniModal/eDniModalInterface';
import { OrderDetailsResponseContent, PostOrder, PostRetake } from './orderManagedInterface';
import { Dashboard } from '../operation/operationsInterface';

const OrderManagedAPI = {
  getMerchantsOrderCall: async (
    cartId: string,
  ): Promise<allResponse<OrderDetailsResponseContent>> => {
    const URL = `${ENVIRONMENT.URL_API_ECOMMERCE}${ENVIRONMENT.URL_API_ECHOP_APIS.URL_API_MERCHANT_ORDERS}?cart_id=${cartId}`;
    const response = await Api.GET(URL);
    return response;
  },
  getOrderRetakeCall: async (
    orderId: string,
  ): Promise<allResponse<OrderDetailsResponseContent>> => {
    const URL = `${ENVIRONMENT.URL_API_ECOMMERCE}${ENVIRONMENT.URL_API_ECHOP_APIS.URL_API_ORDER}/${orderId}`;
    const response = await Api.GET(URL);
    return response;
  },
  postOrderCall: async (orderDetails: OrderDetailsResponseContent) => {
    const URL = `${ENVIRONMENT.URL_API_ECOMMERCE}${ENVIRONMENT.URL_API_ECHOP_APIS.URL_API_ORDER}`;
    const response = await Api.POST(URL, orderDetails);
    return response;
  },
  postOrderInoiceCallNew: async (orderModify: PostOrder) => {
    const URL = `${ENVIRONMENT.URL_API_ECOMMERCE}${ENVIRONMENT.URL_API_ECHOP_APIS.URL_API_ORDER}`;
    const response = await Api.POST(URL, orderModify);
    return response;
  },
  retakes: async (orderDetails: PostRetake, orderId: string) => {
    const modifiedretakeDetails = {
      ...orderDetails,
      process_type: 'RETAKEN',
      view_mode: 'IFRAME',
    };
    const URL = `${ENVIRONMENT.URL_API_ECOMMERCE}${ENVIRONMENT.URL_API_ECHOP_APIS.URL_API_ORDER}/${orderId}/retakes`;
    const response = await Api.POST(URL, modifiedretakeDetails);
    return response;
  },

  resumptions: async (notifyType: NotificationType, orderId: string) => {
    const URL = `${ENVIRONMENT.URL_API_ECOMMERCE}${ENVIRONMENT.URL_API_ECHOP_APIS.URL_API_ORDER}/${orderId}/resumptions`;
    const response = await Api.POST(URL, { notify_type: notifyType });
    return response;
  },
  postSendNotifications: async (notifyType: NotificationType, orderId: string) => {
    const URL = `${ENVIRONMENT.URL_API_ECOMMERCE}${ENVIRONMENT.URL_API_ECHOP_APIS.URL_API_ORDER}/${orderId}/notifications`;
    const response = await Api.POST(URL, { notify_type: notifyType });
    return response;
  },
};

export const {
  getMerchantsOrderCall, postOrderCall, retakes, resumptions, postOrderInoiceCallNew, postSendNotifications, getOrderRetakeCall,
} = OrderManagedAPI;
